import React, { useMemo, useRef } from 'react'

import { Link } from 'react-router-dom'

import { ArrowRightIcon } from '@heroicons/react/24/outline'

import { useLanguage } from '../../contexts/LanguageContext'

import Reveal from '../ui/Reveal'

import { REVEAL_STAGGER } from '../../lib/revealMotion'
import { useLazyWhenVisible } from '../../lib/useLazyWhenVisible'



const aboutMvvBgUrl = `${process.env.PUBLIC_URL || ''}/img/about-mvv-bg.webp`



export default function AboutSection() {

  const { t } = useLanguage()
  const mvvRef = useRef(null)
  const mvvBgReady = useLazyWhenVisible(mvvRef, '400px')



  const pillars = useMemo(

    () => [

      {

        numeral: 'I',

        title: t('aboutSection.mTitle'),

        body: t('aboutSection.mBody'),

      },

      {

        numeral: 'II',

        title: t('aboutSection.vTitle'),

        body: t('aboutSection.vBody'),

      },

      {

        numeral: 'III',

        title: t('aboutSection.valTitle'),

        body: t('aboutSection.valBody'),

      },

    ],

    [t]

  )



  return (

    <section className="border-b border-slate-200/90 bg-transparent">

      <div className="container-max px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16 lg:items-start">

          <Reveal className="lg:col-span-3">

            <p className="section-label">· {t('aboutSection.label')}</p>

          </Reveal>



          <div className="text-flow-justify lg:col-span-9">

            <Reveal delay={REVEAL_STAGGER}>

              <p className="max-w-4xl text-xl font-medium leading-relaxed text-brand-navy sm:text-2xl sm:leading-relaxed">

                {t('aboutSection.lead')}

              </p>

            </Reveal>

            <Reveal delay={REVEAL_STAGGER * 2}>

              <Link

                to="/sobre"

                className="mt-8 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-navy underline decoration-brand-navy/40 underline-offset-4 transition-colors hover:text-brand-blue hover:decoration-brand-blue/50"

              >

                {t('aboutSection.cta')}

                <ArrowRightIcon className="h-4 w-4" aria-hidden />

              </Link>

            </Reveal>

          </div>

        </div>



        <div className="my-14 border-t border-slate-200 sm:my-16 lg:my-20" aria-hidden />



        <div ref={mvvRef} className="relative overflow-hidden rounded-xl border border-slate-200/90 shadow-[0_8px_28px_-6px_rgba(16,34,64,0.22)] ring-1 ring-slate-100/90">

          <div

            className="absolute inset-0 bg-cover bg-center bg-no-repeat brightness-[0.92] saturate-[0.95]"

            style={mvvBgReady ? { backgroundImage: `url(${aboutMvvBgUrl})` } : undefined}

            aria-hidden

          />

          <div className="absolute inset-0 mv-pillars-band opacity-70" aria-hidden />

          <div

            className="absolute inset-0"

            style={{

              background:

                'linear-gradient(180deg, rgba(10, 25, 47, 0.52) 0%, rgba(10, 25, 47, 0.62) 45%, rgba(10, 25, 47, 0.68) 100%)',

            }}

            aria-hidden

          />

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-3">

            {pillars.map((item, index) => (

              <Reveal

                key={item.numeral}

                as="article"

                delay={REVEAL_STAGGER * 3 + index * REVEAL_STAGGER}

                className={[

                  'relative min-h-[220px] border-b border-white/10 px-8 py-10 text-white transition-colors hover:bg-white/[0.04] sm:px-10 sm:py-12 md:border-b-0',

                  index < 2 ? 'md:border-r md:border-white/10' : '',

                ].join(' ')}

              >

                <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-white/65">

                  · {item.numeral}

                </p>

                <h2 className="mt-3 font-heading text-lg font-semibold text-white sm:text-xl">

                  {item.title}

                </h2>

                <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/90 md:max-w-none">

                  {item.body}

                </p>

              </Reveal>

            ))}

          </div>

        </div>

      </div>

    </section>

  )

}


